import { baseRequest } from "./api";
import { API_REFERENCE } from "@base/constants/base.constants";
import { AddBookmarkProps, GetAssetPreplayProps } from "./schemas";

export const getAssetDetails = async (assetId: string) => {
    const params = `?filter=${ encodeURI(JSON.stringify({ deviceTypeId: "1" })) }`;
    return await baseRequest({ url: API_REFERENCE["asset"]["assetdetails"] + assetId + params });
};

export const getAssetPreplay = async ({ assetId, drm }: GetAssetPreplayProps) => {
    const params = `?assetId=${assetId}&drm=${drm}`;
    const showError = !navigator.userAgent.includes("CriOS");
    return await baseRequest({ url: API_REFERENCE["asset"]["preplay"] + params, showError });
}

export const addBookmark = async (body: AddBookmarkProps) => {
    return await baseRequest({
        method: "POST",
        url: API_REFERENCE["asset"]["bookmark"],
        body
    })
}

export const addToWatchlist = async (assetId) => {
    return await baseRequest({
        method: "POST",
        url: API_REFERENCE['asset']['addwatchlist'],
        body: { assetId }
    })
}
